import gql from 'graphql-tag';

const query = gql`
  query ValidateGoalSettings(
    $weight: UserMeasurementWeightInputType!
    $dietMode: DietModeType!
    $goalWeight: UserMeasurementWeightInputType!
  ) {
    me {
      validateGoalSettings(weight: $weight, dietMode: $dietMode, goalWeight: $goalWeight) {
        code
        messages
        details {
          fieldName
          messages
        }
      }
    }
  }
`;

export default query;
